import WidgetDateTimePicker from 'components/Widgets/WidgetDateTimePicker';
import dayjs from 'dayjs';

const DateTypeField = ({ item, selectItem, needTime, setNewSelectItem, disabled, forTable }) => {
  const newDate = () => new Date(item?.value);
  const date = new Date(item);
  const formatDate = () => {
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const onlyDate = () => {
    const { getDay, getMonth, getFullYear } = newDate();
    return `${getDay()} ${getMonth()} ${getFullYear()}`;
  };

  const dateTime = () => {
    const { getHours, getMinutes } = newDate();
    return `${onlyDate()} ${getHours()}:${getMinutes()}`;
  };

  if (forTable) {
    return !item ? null : item?.settings?.time ? (
      <div>{dateTime()}</div>
    ) : item ? (
      <div>{formatDate()}</div>
    ) : (
      <div>{onlyDate()}</div>
    );
  } else {
    return (
      <WidgetDateTimePicker
        selected={
          selectItem?.value && selectItem?.value !== ' '
            ? dayjs(selectItem?.value).format(needTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD')
            : ''
        }
        onChange={(val) =>
          setNewSelectItem({
            value: dayjs(val).format(needTime ? 'YYYY-MM-DDTHH:mm' : 'YYYY-MM-DD') ?? ' ',
            setting: {
              date: dayjs(val).format(needTime ? 'YYYY-MM-DDTHH:mm' : 'YYYY-MM-DD'),
            },
          })
        }
        isDate={true}
        isDateTime={needTime}
        disabled={disabled}
      />
    );
  }
};

export default DateTypeField;
